/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 判断主题是否置灰(true为置灰)
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theme-gray`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
